const payjpKey = process.env.VUE_APP_PAY_JP_PUBLIC_KEY || ''
const serverUrl = process.env.VUE_APP_SERVER_URL
const locale = process.env.VUE_APP_I18N_LOCALE || 'ja'
const fallbackLocale = process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'ja'

const lineUrl = 'https://lin.ee/1Z2jlTe'

export default {
  payjpKey,
  serverUrl,
  lineUrl,
  locale,
  fallbackLocale,
}
